import { createTrackEvent as trackEvent } from 'utils/segment';
import * as t from './actionTypes';

export const formatDefinedFieldsEvent = ({ fields }) => ({ fields, location: 'definePage' });

export const formatBulkDefinedFieldsEvent = ({ fields }) => ({ fields, location: 'bulk-upload' });

export default {
  [t.UPDATE_FIELDS_AND_CATALOG_ITEM_REQUEST]: trackEvent(
    'Catalog Field Types Definition Completed',
    ['fields'],
    formatDefinedFieldsEvent,
  ),
  [t.UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_REQUEST]: trackEvent(
    'Catalog Field Types Definition Completed',
    ['fields'],
    formatBulkDefinedFieldsEvent,
  ),
  [t.UPLOAD_SIZE_EXCEEDED]: trackEvent('Catalog CSV Upload Size Exceeded'),
  [t.SKIP_FIELD_DEFINITION]: trackEvent('Catalog Field Types Definition Skip Attempted'),
  [t.SKIP_FIELD_DEFINITION_AND_UPLOAD_ONLY]: trackEvent('Catalog Field Types Definition Skipped'),
};
